import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Inline = ({ label, text }) => (
  <>
    {label && <span className="text-white/90 font-semibold">{label} </span>}
    {text}
  </>
);

const Block = ({ block }) => {
  if (block.type === "quote") {
    return (
      <blockquote className="my-4 rounded-xl border border-primary/25 bg-white/[0.04] px-5 py-4 text-[14px] md:text-[15px] leading-relaxed text-white/75 italic">
        {block.text}
      </blockquote>
    );
  }
  if (block.type === "ul") {
    return (
      <ul className="my-3 list-disc pl-5 space-y-2 marker:text-primary/70 text-[15px] md:text-base leading-relaxed text-white/70">
        {block.items.map((it, i) => (
          <li key={i}>
            {typeof it === "string" ? it : <Inline label={it.label} text={it.text} />}
          </li>
        ))}
      </ul>
    );
  }
  return (
    <p
      className={`my-3 text-[15px] md:text-base leading-relaxed ${
        block.emphasis ? "text-white/90 font-medium" : "text-white/70"
      }`}
    >
      {block.label ? <Inline label={block.label} text={block.text} /> : block.text}
    </p>
  );
};

const LegalPage = ({ title, accent, updated, sections, testId, docTitle }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    if (docTitle) document.title = docTitle;
  }, [docTitle]);

  return (
    <div className="bg-background min-h-screen flex flex-col" data-testid={testId}>
      <Header />
      <main className="flex-1 pt-28 md:pt-32 pb-24 px-[5%]">
        <div className="max-w-[820px] mx-auto">
          <span className="inline-flex items-center rounded-full border border-primary/40 bg-primary/[0.1] px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.28em] text-primary">
            Legal
          </span>
          <h1
            className="mt-6 font-display font-black uppercase leading-[1.05] text-[34px] md:text-[52px] text-white"
            data-testid="legal-title"
          >
            {title} {accent && <span className="text-gold-gradient">{accent}</span>}
          </h1>
          {updated && <p className="mt-4 text-sm text-white/45">{updated}</p>}

          <div className="mt-10 space-y-10">
            {sections.map((s, i) => (
              <section key={i}>
                {s.heading && (
                  <h2 className="font-display font-bold uppercase tracking-wide text-lg md:text-xl text-primary">
                    {s.heading}
                  </h2>
                )}
                <div className="mt-2">
                  {s.blocks.map((b, j) => (
                    <Block key={j} block={b} />
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
